// ProfessionalPTO.jsx

// Dependencies
import React, { useState, useEffect } from 'react';

// Services
import { getProfessionalPTORanges, addProfessionalPTORange, deleteProfessionalPTORange } from '@/services/schedulingService';

const ProfessionalPTO = ({ professionalID, onUpdate }) => {
  const [ptoRanges, setPtoRanges] = useState([]);
  const [newStart, setNewStart] = useState('');
  const [newEnd, setNewEnd] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRanges();
  }, [professionalID]);

  async function fetchRanges() {
    try {
      const ranges = await getProfessionalPTORanges(professionalID);
      setPtoRanges(ranges || []);
    } catch (e) {
      console.error(e);
    }
  }

  async function handleAdd() {
    if (!newStart || !newEnd) return;
    setLoading(true);
    try {
      await addProfessionalPTORange(professionalID, newStart, newEnd, '');
      setNewStart('');
      setNewEnd('');
      await fetchRanges();
      if (onUpdate) onUpdate();
    } catch(e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(ptoId) {
     if(!window.confirm("Delete PTO range?")) return;
     try {
       await deleteProfessionalPTORange(ptoId);
       await fetchRanges();
       if (onUpdate) onUpdate();
     } catch(e){
       console.error(e);
     }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <div>
        {ptoRanges.map(range => (
          <div key={range.PTOID} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
             <span style={{ marginRight: '10px', fontSize: '14px' }}>
               {new Date(Array.isArray(range.StartDate) ? range.StartDate[0] : range.StartDate).toLocaleDateString()} - {new Date(Array.isArray(range.EndDate) ? range.EndDate[0] : range.EndDate).toLocaleDateString()}
             </span>
             <button title="Delete PTO" onClick={() => handleDelete(range.PTOID)} style={{ cursor: 'pointer', color: 'red', background: 'none', border: 'none', fontWeight: 'bold' }}>✕</button>
          </div>
        ))}
        {ptoRanges.length === 0 && <div style={{fontStyle: 'italic', color: '#666', fontSize: '14px'}}>No PTO configured</div>}
      </div>
      
      <div style={{ display: 'flex', gap: '5px', alignItems: 'center', flexWrap: 'wrap' }}>
          <input type="date" value={newStart} onChange={e => setNewStart(e.target.value)} style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0, flex: '1 1 120px' }} />
          <span style={{ fontSize: '12px' }}>to</span>
          <input type="date" value={newEnd} onChange={e => setNewEnd(e.target.value)} style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0, flex: '1 1 120px' }} />
          <button onClick={handleAdd} disabled={loading || !newStart || !newEnd} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc', cursor: 'pointer', backgroundColor: '#f0f0f0' }}>Add</button>
      </div>
    </div>
  );
};

export default ProfessionalPTO;
